module.exports = __webpack_public_path__ + "img/Stemness-OVCA_10X_WTA.b5c71b5a.png";